<template>
	
	<div>
		<el-dialog
		  title="供应商列表"
		  :visible.sync="dialogVisible"
		  width="65%"
		 >
		 <div style="display: flex;">
		 <el-input style="width: 200px;margin-right: 50px;" v-model="queryParams.supplierName" placeholder="请输入供应商名称"/>
		  <el-input style="width: 200px;margin-right: 50px;" v-model="queryParams.idCardNumber" placeholder="请输入供应商身份证号码"/>
		  <el-button @click = "searchSupplier">搜索</el-button>
		  </div>
	    <el-table
	      :data="tableData"
	      style="width: 100%"
		  v-loading="loading">
	   <el-table-column prop="serialNumber" label="供应商编号"/>
	   <el-table-column prop="supplierName" label="供应商名称"/>
	   <el-table-column prop="supplierPhone" label="手机号码"/>
	  <!-- <el-table-column prop="certificationStatus" label="认证状态">
	     <template slot-scope="scope">
	       <div v-for="item in dictMap.supplier_audit_status" :key="item.id">
	         <span v-if="scope.row.certificationStatus === item.value">{{ item.label }}</span>
	       </div>
	     </template>
	   </el-table-column> -->
	  <!-- <el-table-column prop="sumbitTime" label="申请时间">
	     <template slot-scope="scope">
	       <span>{{ parseTime(scope.row.sumbitTime) }}</span>
	     </template>
	   </el-table-column> -->
	   <el-table-column prop="idCardNumber" label="身份证号码"/>
	   <el-table-column prop="idCardImg" label="身份证图片">
	   <template slot-scope="scope">
	     <img style="width: 100px;height: 100px;" :src ="getSrc(scope.row.idCardImg)"/>
	   </template>
	   </el-table-column>
	   <el-table-column  label="查看协议">
	   <template slot-scope="scope">
	     <el-button @click="openContact(scope.row)">服务协议</el-button>
		
	   </template>
	   </el-table-column>
	   <el-table-column  label="下载协议">
	   <template slot-scope="scope">
	     <el-button @click="downloadContact(scope.row)">下载pdf</el-button>
	   		
	   </template>
	   </el-table-column>
	    </el-table>
	  <el-pagination style="margin-top: 2vw;margin-bottom: 2vw;"
	   
	  @current-change="currentChange"
	   
	   background layout="prev, pager, next" :total="total">
	  </el-pagination>
	  </el-dialog>
	  <el-dialog
	    title="自由职业者服务协议"
	    :visible.sync="showContact"
	    width="50%"
	    >
	    <contact :row = "row"/>
	    <span slot="footer" class="dialog-footer">
	      <el-button @click="showContact = false">取 消</el-button>
	      <el-button type="primary" @click="showContact = false">确 定</el-button>
	    </span>
	  </el-dialog>
	</div>
	
</template>

<script>

import {querySupplier,downloadContactApi} from '../../../api/supplier.js'
import initDict from '../../../mixins/initDict.js'
import {parseTime} from '../../../utils/index.js'
import contact from '../../contact/contact.vue'
	export default{
		components:{
			contact
		},
		mixins:[initDict],
		data(){
			
			return {
				row:{},
				dialogVisible:false,
				page:0,
				size:10,
				total:0,
				tableData:[],
				loading:false,
				queryParams:{
					supplierName:"",
					idCardNumber:""
				},
				showContact:false
				
			}
			
		},
		created() {
			this.$nextTick(()=>{
				this.getDict('supplier_audit_status')
			})
			
		},
		methods:{
			
			parseTime,
			searchSupplier(){
				const sort = 'sumbitTime,desc'
				let params = {
					page: this.page,
					size: this.size,
					sort: sort,
					...this.queryParams
				}
				params = this.cleanParam(params)
				this.loadSupplier(params)
				
				
				
			},
			cleanParam(p){
				let r = {}
				for(let o of Object.keys(p)){
					if(p[o]) r[o] = p[o]
					else continue
				}
				return r
			},
			getSrc(img){
				
				if(img&&img.indexOf(",")>0){
					
					return img.split(",")[0]
					
				}else{
					return img
				}
				
				
			},
			loadSupplier(params){
				this.loading = true
				querySupplier(params).then(res=>{
					console.log('[res]',res);
					this.tableData = res.content
					this.total = res.totalElements
					this.loading = false
					
				})
			},
			currentChange(e){
				const sort = 'sumbitTime,desc'
				let params = {
					page: e-1,
					size: this.size,
					sort: sort
				}
				
				this.loadSupplier(params)
			},
			openContact(row){
				this.row = row
				this.showContact=!this.showContact
			},
			downloadContact(row){
			
				downloadContactApi(row).then(res=>{
					console.log('[res]',res);
					window.open(res,"_blank")
				})
				
			}
			
		},
		watch:{
			dialogVisible:function(val){
				
				if(val){
					
					const sort = 'sumbitTime,desc'
					let params = {
						page: this.page,
						size: this.size,
						sort: sort
					}
					this.loadSupplier(params)
					
				}
				
			}
		}
		
	}

</script>

<style>
</style>
